<template>
  <div class="dashboard-container">
    <side-bar />
    <div class="main-content">
      <h2>New Partner Sign-Up</h2>
      <hr class="h2"/>
      <div class="container">
        <component src="https://c2hbe361.caspio.com/dp/76bfd000d9bc00e5af264afaa8ff/emb" :is="'script'"></component>
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from './SideBar.vue'

export default {
  name: 'NewPartner',
  components: {
    SideBar
  }
}
</script>